export default class StoreErrorDTO {
  constructor({ err, module, errorResponse, logIpAddress = false } = {}) {
    /**
     * @type {Error} complete error trace, contains the `message` and `error stack`
     */
    this.err = err

    /**
     * @type {String} Name of module the error occurred in
     */
    this.module = module

    /**
     * @type {ErrorResponse} Object that determines which error page to display based on error returned from response
     */
    this.errorResponse = errorResponse

    /**
     * @type {Boolean} Indicates whether or not to log the user's IP address
     */
    this.logIpAddress = logIpAddress
  }
}
